import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const Summary = () => {
  const [show, setShow] = useState(false);
  const { totalPrice } = useSelector((store) => store.order);
  const subTotal = totalPrice.toFixed(2);

  const total = subTotal - 10 - 5;
  return (
    <article className=" px-10 py-5 shadow-md rounded-2xl drop-shadow-lg bg-gray-3 ">
      <button
        type="button"
        onClick={() => setShow(!show)}
        className={`mx-auto text-xl font-semibold text-dark-4 hover:text-primary-5 mb-4 ${
          !show && 'border-2 border-primary-5 px-4 py-1 rounded-md'
        }`}
      >
        Summary
      </button>
      {show && (
        <div className={` flex flex-col gap-4 lg:gap-9 w-full `}>
          <div className="flex  justify-between text-dark-3 ">
            <p>Subtotal</p>
            <p className=" font-bold">${subTotal}</p>
          </div>
          <div className="flex  justify-between text-dark-3 ">
            <p>Delivery Charge</p>
            <p className=" font-bold">$5</p>
          </div>
          <div className="flex justify-between text-dark-3">
            <p>Discount</p>
            <p className="font-bold">$10</p>
          </div>
          <hr />
          <div className="flex justify-between text-dark-4 font-bold">
            <h4>Total</h4>
            <p>${total} </p>
          </div>
        </div>
      )}
    </article>
  );
};

export default Summary;
